export const CAMPAIGN_STATUS_ACTIVE = 1;
export const CAMPAIGN_STATUS_PAUSED = 2;
export const CAMPAIGN_STATUS_DELETED = 3;
export const CAMPAIGN_STATUS_PENDING = 4;

export const CAMPAIGN_GOAL_TRAFFIC = 'traffic';
export const CAMPAIGN_GOAL_LEADS = 'leads';
export const CAMPAIGN_GOAL_CONVERSIONS = 'pixel_conversions';
export const CAMPAIGN_GOAL_SMART_CLICKS = 'smart_clicks';
